import McOperateBar from './McOperateBar.vue'

McOperateBar.install = function(Vue){
    Vue.component(McOperateBar.name, McOperateBar);
}

export default McOperateBar;